(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vunoti-homepage"] && !Shopify.designMode) return;
  try {
    
  const setupVunotiSliders = () => {
    document.querySelectorAll('[data-vunoti-slider]').forEach((slider) => {
      if (slider.dataset.ready === 'true') return;
      slider.dataset.ready = 'true';
      const slides = Array.from(slider.querySelectorAll('[data-vunoti-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-vunoti-dot]'));
      const previous = slider.querySelector('[data-vunoti-prev]');
      const next = slider.querySelector('[data-vunoti-next]');
      let index = 0;
      let timer;
      let transitionTimer;
      let paused = false;
      let inViewport = true;
      const duration = Number(slider.dataset.duration) || 7000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const shouldAutoplay = slides.length > 1 && slider.dataset.autoplay === 'true' && !reduceMotion;

      const schedule = () => {
        if (timer) window.clearTimeout(timer);
        if (!shouldAutoplay || paused || !inViewport) return;
        timer = window.setTimeout(() => show(index + 1, 'next'), duration);
      };

      const updateProgress = () => {
        dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', 'false');
        });
        window.requestAnimationFrame(() => {
          dots[index]?.setAttribute('aria-current', 'true');
        });
      };

      const show = (target, direction = 'next') => {
        const nextIndex = (target + slides.length) % slides.length;
        if (nextIndex === index) {
          updateProgress();
          schedule();
          return;
        }

        const outgoing = slides[index];
        const incoming = slides[nextIndex];
        if (transitionTimer) window.clearTimeout(transitionTimer);
        slider.dataset.direction = direction;
        outgoing.dataset.leaving = 'true';
        delete outgoing.dataset.active;
        incoming.dataset.entering = 'true';
        incoming.dataset.active = 'true';
        incoming.setAttribute('aria-hidden', 'false');
        index = nextIndex;
        updateProgress();

        transitionTimer = window.setTimeout(() => {
          slides.forEach((slide, slideIndex) => {
            delete slide.dataset.entering;
            delete slide.dataset.leaving;
            slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
          });
        }, reduceMotion ? 20 : 940);
        schedule();
      };

      const pause = () => {
        paused = true;
        slider.style.setProperty('--vunoti-hero-play-state', 'paused');
        if (timer) window.clearTimeout(timer);
      };

      const resume = () => {
        paused = false;
        slider.style.setProperty('--vunoti-hero-play-state', 'running');
        updateProgress();
        schedule();
      };

      previous?.addEventListener('click', () => show(index - 1, 'previous'));
      next?.addEventListener('click', () => show(index + 1, 'next'));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = Number(dot.dataset.vunotiDot);
          show(target, target < index ? 'previous' : 'next');
        });
      });

      slider.addEventListener('pointerenter', pause);
      slider.addEventListener('pointerleave', resume);
      slider.addEventListener('focusin', pause);
      slider.addEventListener('focusout', (event) => {
        if (!slider.contains(event.relatedTarget)) resume();
      });

      if (shouldAutoplay && 'IntersectionObserver' in window) {
        inViewport = false;
        const autoplayObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            inViewport = entry.isIntersecting;
            if (inViewport) {
              schedule();
            } else if (timer) {
              window.clearTimeout(timer);
            }
          });
        }, { threshold: 0.16 });
        autoplayObserver.observe(slider);
      }

      schedule();
    });

    document.querySelectorAll('[data-vunoti-quote]').forEach((quote) => {
      if (quote.dataset.ready === 'true') return;
      quote.dataset.ready = 'true';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) {
        quote.classList.add('is-visible');
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });
      }, { threshold: 0.32 });
      observer.observe(quote);
    });

    document.querySelectorAll('[data-vunoti-product-rail]').forEach((rail) => {
      if (rail.dataset.ready === 'true') return;
      rail.dataset.ready = 'true';
      const track = rail.querySelector('[data-best-seller-track]');
      const previous = rail.querySelector('[data-best-seller-prev]');
      const next = rail.querySelector('[data-best-seller-next]');
      const progress = rail.querySelector('[data-best-seller-progress]');
      const updateProgress = () => {
        if (!track || !progress) return;
        const maximum = track.scrollWidth - track.clientWidth;
        const visibleRatio = Math.min(1, track.clientWidth / track.scrollWidth);
        const travelledRatio = maximum > 0 ? track.scrollLeft / maximum : 0;
        progress.style.width = `${Math.max(visibleRatio * 100, 18)}%`;
        progress.style.transform = `translateX(${travelledRatio * ((1 / Math.max(visibleRatio, 0.18)) - 1) * 100}%)`;
      };
      const scrollByCard = (direction) => {
        const card = track?.querySelector('.vunoti-product-card');
        if (!track || !card) return;
        const styles = getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || 0);
        track.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: 'smooth'
        });
      };
      previous?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));
      track?.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress, { passive: true });
      updateProgress();
    });

    document.querySelectorAll('[data-vunoti-carousel]').forEach((carousel) => {
      if (carousel.dataset.ready === 'true') return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('.vunoti-carousel__track');
      carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => {
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
      });
      carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => {
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });

    document.querySelectorAll('[data-vunoti-youtube]').forEach((video) => {
      if (video.dataset.ready === 'true') return;
      video.dataset.ready = 'true';
      const holder = video.querySelector('.vunoti-ajrakh__video');
      const playButton = video.querySelector('[data-vunoti-youtube-play]');
      const videoId = video.dataset.videoId;
      let iframe;

      const command = (func) => {
        iframe?.contentWindow?.postMessage(JSON.stringify({ event: 'command', func, args: [] }), '*');
      };

      const loadVideo = () => {
        if (iframe || !holder || !videoId) return;
        iframe = document.createElement('iframe');
        iframe.title = 'Ajrakh making process';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&mute=1&loop=1&playlist=${encodeURIComponent(videoId)}&playsinline=1&rel=0&enablejsapi=1`;
        holder.replaceChildren(iframe);
      };

      playButton?.addEventListener('click', loadVideo);
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadVideo();
            window.setTimeout(() => command('playVideo'), 500);
          } else {
            command('pauseVideo');
          }
        });
      }, { threshold: 0.42 });
      observer.observe(video);
    });
  };

  setupVunotiSliders();
  document.addEventListener('shopify:section:load', setupVunotiSliders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vunoti-track-order"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const humanize = (value) =>
      value
        ? value
            .toLowerCase()
            .split('_')
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join(' ')
        : 'Not available';

    const addText = (element, value) => {
      element.textContent = value == null ? '' : String(value);
      return element;
    };

    const make = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text != null) addText(element, text);
      return element;
    };

    const formatDate = (value) => {
      if (!value) return 'Not available';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return 'Not available';
      return new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }).format(date);
    };

    const formatMoney = (money) => {
      if (!money || Number.isNaN(Number(money.amount))) return 'Not available';
      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: money.currencyCode,
          maximumFractionDigits: 2,
        }).format(Number(money.amount));
      } catch {
        return `${money.currencyCode} ${money.amount}`;
      }
    };

    const addFact = (list, label, value) => {
      const wrapper = make('div', 'vunoti-track__fact');
      wrapper.append(make('dt', '', label), make('dd', '', value));
      list.append(wrapper);
    };

    const renderOrder = (container, order) => {
      container.replaceChildren();

      const head = make('div', 'vunoti-track__result-head');
      const heading = make('div');
      heading.append(
        make('p', 'vunoti-track__result-kicker', 'Latest status'),
        make('h2', 'vunoti-track__result-title', `Order ${order.number}`),
      );
      const status = make('span', `vunoti-track__status vunoti-track__status--${order.status.key}`, order.status.label);
      head.append(heading, status);
      container.append(head);

      if (order.status.step > 0) {
        const timeline = make('ol', 'vunoti-track__timeline');
        ['Confirmed', 'Processing', 'Shipped', 'Delivered'].forEach((label, index) => {
          const item = make('li', 'vunoti-track__timeline-item', label);
          if (index + 1 <= order.status.step) item.classList.add('is-complete');
          timeline.append(item);
        });
        container.append(timeline);
      }

      const facts = make('dl', 'vunoti-track__facts');
      addFact(facts, 'Placed on', formatDate(order.createdAt));
      addFact(facts, 'Payment', humanize(order.paymentStatus));
      addFact(facts, 'Order total', formatMoney(order.total));
      container.append(facts);

      if (Array.isArray(order.items) && order.items.length) {
        container.append(make('h3', 'vunoti-track__subheading', 'Items in this order'));
        const items = make('ul', 'vunoti-track__items');
        order.items.forEach((product) => {
          const item = make('li', 'vunoti-track__item');
          if (product.image?.url) {
            const image = make('img', 'vunoti-track__item-image');
            image.src = product.image.url;
            image.alt = product.image.alt || '';
            image.loading = 'lazy';
            item.append(image);
          } else {
            item.append(make('span', 'vunoti-track__item-placeholder'));
          }
          item.append(
            make('p', 'vunoti-track__item-name', product.name),
            make('span', 'vunoti-track__item-quantity', `Qty ${product.quantity}`),
          );
          items.append(item);
        });
        container.append(items);
      }

      const shipments = Array.isArray(order.shipments) ? order.shipments : [];
      if (shipments.length) {
        container.append(make('h3', 'vunoti-track__subheading', shipments.length > 1 ? 'Shipments' : 'Shipment'));
        shipments.forEach((shipment, index) => {
          const panel = make('div', 'vunoti-track__shipment');
          const deliveryDate = shipment.deliveredAt || shipment.estimatedDeliveryAt;
          const deliveryLabel = shipment.deliveredAt ? 'Delivered' : 'Estimated delivery';
          panel.append(
            make(
              'p',
              '',
              `${shipments.length > 1 ? `Shipment ${index + 1} · ` : ''}${humanize(shipment.status)}`,
            ),
          );
          if (deliveryDate) panel.append(make('p', '', `${deliveryLabel}: ${formatDate(deliveryDate)}`));

          (shipment.tracking || []).forEach((tracking) => {
            const link = make('a', '', `Track with ${tracking.company}`);
            link.href = tracking.url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            panel.append(link);
          });
          container.append(panel);
        });
      }

      container.hidden = false;
      container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    document.querySelectorAll('[data-vunoti-track-order]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const form = section.querySelector('[data-track-form]');
      const message = section.querySelector('[data-track-message]');
      const result = section.querySelector('[data-track-result]');
      const submit = section.querySelector('[data-track-submit]');
      const submitLabel = section.querySelector('[data-track-submit-label]');
      const endpoint = section.dataset.endpoint;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        message.hidden = true;
        result.hidden = true;
        result.replaceChildren();

        if (!form.reportValidity()) return;

        const formData = new FormData(form);
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        submitLabel.textContent = 'Checking...';

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              orderNumber: formData.get('orderNumber'),
              contact: formData.get('contact'),
            }),
          });
          const payload = await response.json().catch(() => ({}));
          if (!response.ok || !payload.order) {
            throw new Error(payload.error || 'Order tracking is temporarily unavailable. Please try again shortly.');
          }
          renderOrder(result, payload.order);
        } catch (error) {
          message.textContent = error.message;
          message.hidden = false;
        } finally {
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
          submitLabel.textContent = 'Track order';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
